/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * VideoPauseIcon - Auto-generated from icon.js
 */
export const VideoPauseIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
		<circle cx="20" cy="20" r="20" fill="black" fillOpacity="0.5" />
		<path fillRule="evenodd" clipRule="evenodd" d="M18 12H14V28H18V12ZM26 12H22V28H26V12Z" fill="white" />
	</svg>
);

export default VideoPauseIcon;
